// src/pages/SubmoduleFormats.jsx
import React from "react";

export default function SubmoduleFormats() {
  return <div>Submódulo en construcción</div>;
}